<template>
  <div class="event-interests-form">
    <div :class="[ confirmed ? 'display' : '', 'request-confirmation' ]">
      <p>{{ $t('eventInterests.confirmation') }}</p>
    </div>
    <div v-if="!confirmed">
      <div class="col-md-4">
        <div
          v-for="category in categories[0]"
          :key="category.name"
          class="panel panel-default"
        >
          <div
            class="panel-heading"
            @click="category.isVisible = !category.isVisible"
          >
            <p
              class="panel-title"
            >
              {{ category.name }}
              <i
                class="icon"
                :class="category.isVisible ? 'ion-md-remove' : 'ion-md-add'"
              />
            </p>
          </div>
          <transition name="slide">
            <div
              v-if="category.isVisible"
              class="panel-body"
            >
              <div
                v-for="event in category.events"
                :key="event.id"
                class="checkbox"
              >
                <label>
                  <input
                    v-model="selectedEvents"
                    :value="event.sf_event_name"
                    type="checkbox"
                  >
                  {{ event.display_name }}
                </label>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="col-md-4">
        <div
          v-for="category in categories[1]"
          :key="category.name"
          class="panel panel-default"
        >
          <div
            class="panel-heading"
            @click="category.isVisible = !category.isVisible"
          >
            <p
              class="panel-title"
            >
              {{ category.name }}
              <i
                class="icon"
                :class="category.isVisible ? 'ion-md-remove' : 'ion-md-add'"
              />
            </p>
          </div>
          <transition name="slide">
            <div
              v-if="category.isVisible"
              class="panel-body"
            >
              <div
                v-for="event in category.events"
                :key="event.id"
                class="checkbox"
              >
                <label>
                  <input
                    v-model="selectedEvents"
                    :value="event.sf_event_name"
                    type="checkbox"
                  >
                  {{ event.display_name }}
                </label>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="col-md-4">
        <div
          v-for="category in categories[2]"
          :key="category.name"
          class="panel panel-default"
        >
          <div
            class="panel-heading"
            @click="category.isVisible = !category.isVisible"
          >
            <p
              class="panel-title"
            >
              {{ category.name }}
              <i
                class="icon"
                :class="category.isVisible ? 'ion-md-remove' : 'ion-md-add'"
              />
            </p>
          </div>
          <transition name="slide">
            <div
              v-if="category.isVisible"
              class="panel-body"
            >
              <div
                v-for="event in category.events"
                :key="event.id"
                class="checkbox"
              >
                <label>
                  <input
                    v-model="selectedEvents"
                    :value="event.sf_event_name"
                    type="checkbox"
                  >
                  {{ event.display_name }}
                </label>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="col-md-12 save-btn">
        <div
          v-if="in_eu"
          class="checkbox"
        >
          <label>
            <input
              id="event_interests_marketing_consent"
              v-validate="'required'"
              class="boolean required"
              type="checkbox"
              name="marketing_email_consent"
            >
            <span class="custom-checkbox" />
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="$t('form.marketing_email_consent')" />
            <!--eslint-enable-->
            <template v-if="errors.has('marketing_email_consent')">
              <br>
              <strong
                class="error"
                for="marketing_email_consent"
              >{{ errors.first('marketing_email_consent') }}</strong>
            </template>
          </label>
        </div>
        <div
          class="btn btn-secondary"
          @click="submitForm"
        >
          {{ $t('eventInterests.saveBtn') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global locale */

export default {
  name: 'EventInterestForm',
  data() {
    return {
      categories: [[], [], []],
      clientEmail: '',
      selectedEvents: [],
      disabled: false,
      confirmed: false,
      in_eu: false,
    }
  },

  computed:{
    getToken(){
      let tok = document.getElementsByTagName('meta')['csrf-token']
      if (tok) { // csrf-token is null in testing
        tok = tok.getAttribute('content')
      }
      return tok
    }
  },


  mounted() {
    this.validateUrl()
    this.fetchEvents()
  },

  methods: {
    validateUrl() {
      const url_string = window.location.href
      const url = new URL(url_string)
      if (!url.searchParams.has('email')) {
        window.location.href = '/'
      }
      this.clientEmail = url.searchParams.get('email')
    },
    async fetchEvents() {
      var eventTypeDiv = document.getElementById('eventTypeDiv')
      var eventType
      if (eventTypeDiv && eventTypeDiv.dataset.eventType) eventType = eventTypeDiv.dataset.eventType
      const response = await fetch(
        `/api/info_requests/dropdown.json?locale=${locale}&event_type=${eventType}`
      )
      const body = await response.json()
      this.in_eu = body.in_eu
      for (let i = 0; i < body.categories.length; i++) {
        body.categories[i].isVisible = false
        let column = i % 3
        this.categories[column].push(body.categories[i])
      }
    },
    submitForm() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.disabled = true
          this.postForm()
        } else {
          for (let field of this.$validator.fields) {
            field.update({events: 'input|blur'})
          }
        }
      })
    },
    async postForm() {
      try {
        const response = await fetch('/api/event_interests', {
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': this.getToken
          },
          method: 'POST',
          body: JSON.stringify({
            client_email: this.clientEmail,
            selected_events: this.selectedEvents,
          })
        })
        if (!response.ok) { throw 'Bad response' }
        this.disabled = false
        this.confirmed = true
      } catch(err) {
        this.disabled = false
      }
    }
  }
}
</script>
